import useTheme from '@/theme/useTheme';
import { Grid, useMediaQuery } from '@mui/material';
import React from 'react';

interface ResponsiveTwoColumnLayoutProps {
  leftComponent: React.ReactNode;
  rightComponent: React.ReactNode;
  sx?: Record<string, any>;
}

const ResponsiveTwoColumnLayout: React.FC<ResponsiveTwoColumnLayoutProps> = ({
  leftComponent,
  rightComponent,
  sx = {},
}) => {
  const { theme } = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Grid container spacing={isSmallScreen ? 2 : 2} sx={sx}>
      <Grid item xs={12} md={6}>
        {leftComponent}
      </Grid>
      <Grid item xs={12} md={6}>
        {rightComponent}
      </Grid>
    </Grid>
  );
};

export default ResponsiveTwoColumnLayout;
